import {
  INVOICE_DRAFT_LIST_REQUEST,
  INVOICE_DRAFT_LIST_SUCCESS,
  INVOICE_DRAFT_LIST_FAILURE,
  INVOICE_DRAFT_SEARCH_REQUEST,
  INVOICE_DRAFT_SEARCH_SUCCESS,
  INVOICE_DRAFT_SEARCH_FAILURE,
  INVOICE_DRAFT_CREATE_REQUEST,
  INVOICE_DRAFT_CREATE_SUCCESS,
  INVOICE_DRAFT_CREATE_FAILURE,
  INVOICE_DRAFT_UPDATE_REQUEST,
  INVOICE_DRAFT_UPDATE_SUCCESS,
  INVOICE_DRAFT_UPDATE_FAILURE,
  INVOICE_DRAFT_VOID_REQUEST,
  INVOICE_DRAFT_VOID_SUCCESS,
  INVOICE_DRAFT_VOID_FAILURE,
  INVOICE_DRAFT_PDF_REQUEST,
  INVOICE_DRAFT_PDF_SUCCESS,
  INVOICE_DRAFT_PDF_FAILURE,
  INVOICE_DRAFT_DAILY_BALANCE_REQUEST,
  INVOICE_DRAFT_DAILY_BALANCE_SUCCESS,
  INVOICE_DRAFT_DAILY_BALANCE_FAILURE,
  INVOICE_DRAFT_STATUS_LIST_REQUEST,
  INVOICE_DRAFT_STATUS_LIST_SUCCESS,
  INVOICE_DRAFT_STATUS_LIST_FAILURE,
  INVOICE_DRAFT_STATUS_DATA_REQUEST,
  INVOICE_DRAFT_STATUS_DATA_SUCCESS,
  INVOICE_DRAFT_STATUS_DATA_FAILURE,
  INVOICE_DRAFT_STATUS_CREATE_REQUEST,
  INVOICE_DRAFT_STATUS_CREATE_SUCCESS,
  INVOICE_DRAFT_STATUS_CREATE_FAILURE,
  INVOICE_DRAFT_STATUS_UPDATE_REQUEST,
  INVOICE_DRAFT_STATUS_UPDATE_SUCCESS,
  INVOICE_DRAFT_STATUS_UPDATE_FAILURE,
  INVOICE_DRAFT_STATUS_DELETE_REQUEST,
  INVOICE_DRAFT_STATUS_DELETE_SUCCESS,
  INVOICE_DRAFT_STATUS_DELETE_FAILURE,
  INVOICE_DRAFT_DATA_REQUEST,
  INVOICE_DRAFT_DATA_SUCCESS,
  INVOICE_DRAFT_DATA_FAILURE,
  INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_REQUEST,
  INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_SUCCESS,
  INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_FAILURE,
  INVOICE_DRAFT_CONVERT_TO_INVOICE_REQUEST,
  INVOICE_DRAFT_CONVERT_TO_INVOICE_SUCCESS,
  INVOICE_DRAFT_CONVERT_TO_INVOICE_FAILURE,
} from "./actionType";

const initialState = {
  invoiceDraftList: [],
  invoiceDraftListLoading: false,
  invoiceDraftListError: null,
  invoiceDraftSearch: [],
  invoiceDraftSearchLoading: false,
  invoiceDraftSearchError: null,
  invoiceDraftCreate: {},
  invoiceDraftCreateLoading: false,
  invoiceDraftCreateError: null,
  invoiceDraftUpdate: {},
  invoiceDraftUpdateLoading: false,
  invoiceDraftUpdateError: null,
  invoiceDraftVoid: {},
  invoiceDraftVoidLoading: false,
  invoiceDraftVoidError: null,
  invoiceDraftPdf: {},
  invoiceDraftPdfLoading: false,
  invoiceDraftPdfError: null,
  invoiceDraftDailyBalance: {},
  invoiceDraftDailyBalanceLoading: false,
  invoiceDraftDailyBalanceError: null,
  invoiceDraftStatusList: [],
  invoiceDraftStatusListLoading: false,
  invoiceDraftStatusListError: null,
  invoiceDraftStatusData: {},
  invoiceDraftStatusDataLoading: false,
  invoiceDraftStatusDataError: null,
  invoiceDraftStatusCreate: {},
  invoiceDraftStatusCreateLoading: false,
  invoiceDraftStatusCreateError: null,
  invoiceDraftStatusUpdate: {},
  invoiceDraftStatusUpdateLoading: false,
  invoiceDraftStatusUpdateError: null,
  invoiceDraftStatusDelete: {},
  invoiceDraftStatusDeleteLoading: false,
  invoiceDraftStatusDeleteError: null,
  invoiceDraftData: [],
  invoiceDraftDataLoading: false,
  invoiceDraftDataError: null,
  invoiceDraftActivityLogSearch: [],
  invoiceDraftActivityLogSearchLoading: false,
  invoiceDraftActivityLogSearchError: null,
  invoiceDraftConvertToInvoice: {},
  invoiceDraftConvertToInvoiceLoading: false,
  invoiceDraftConvertToInvoiceError: null,
};

const invoiceDraftReducer = (state = initialState, action) => {
  switch (action.type) {
    case INVOICE_DRAFT_LIST_REQUEST:
      return {
        ...state,
        invoiceDraftListLoading: true,
        invoiceDraftListError: null,
      };
    case INVOICE_DRAFT_LIST_SUCCESS:
      return {
        ...state,
        invoiceDraftList: action.payload,
        invoiceDraftListLoading: false,
      };
    case INVOICE_DRAFT_LIST_FAILURE:
      return {
        ...state,
        invoiceDraftListLoading: false,
        invoiceDraftListError: action.payload,
      };
    case INVOICE_DRAFT_SEARCH_REQUEST:
      return {
        ...state,
        invoiceDraftSearchLoading: true,
        invoiceDraftSearchError: null,
      };
    case INVOICE_DRAFT_SEARCH_SUCCESS:
      return {
        ...state,
        invoiceDraftSearch: action.payload,
        invoiceDraftSearchLoading: false,
      };
    case INVOICE_DRAFT_SEARCH_FAILURE:
      return {
        ...state,
        invoiceDraftSearchLoading: false,
        invoiceDraftSearchError: action.payload,
      };
    case INVOICE_DRAFT_CREATE_REQUEST:
      return {
        ...state,
        invoiceDraftCreateLoading: true,
        invoiceDraftCreateError: null,
      };
    case INVOICE_DRAFT_CREATE_SUCCESS:
      return {
        ...state,
        invoiceDraftCreate: action.payload,
        invoiceDraftCreateLoading: false,
      };
    case INVOICE_DRAFT_CREATE_FAILURE:
      return {
        ...state,
        invoiceDraftCreateLoading: false,
        invoiceDraftCreateError: action.payload,
      };
    case INVOICE_DRAFT_UPDATE_REQUEST:
      return {
        ...state,
        invoiceDraftUpdateLoading: true,
        invoiceDraftUpdateError: null,
      };
    case INVOICE_DRAFT_UPDATE_SUCCESS:
      return {
        ...state,
        invoiceDraftUpdate: action.payload,
        invoiceDraftUpdateLoading: false,
      };
    case INVOICE_DRAFT_UPDATE_FAILURE:
      return {
        ...state,
        invoiceDraftUpdateLoading: false,
        invoiceDraftUpdateError: action.payload,
      };
    case INVOICE_DRAFT_VOID_REQUEST:
      return {
        ...state,
        invoiceDraftVoidLoading: true,
        invoiceDraftVoidError: null,
      };
    case INVOICE_DRAFT_VOID_SUCCESS:
      return {
        ...state,
        invoiceDraftVoid: action.payload,
        invoiceDraftVoidLoading: false,
      };
    case INVOICE_DRAFT_VOID_FAILURE:
      return {
        ...state,
        invoiceDraftVoidLoading: false,
        invoiceDraftVoidError: action.payload,
      };
    case INVOICE_DRAFT_PDF_REQUEST:
      return {
        ...state,
        invoiceDraftPdfLoading: true,
        invoiceDraftPdfError: null,
      };
    case INVOICE_DRAFT_PDF_SUCCESS:
      return {
        ...state,
        invoiceDraftPdf: action.payload,
        invoiceDraftPdfLoading: false,
      };
    case INVOICE_DRAFT_PDF_FAILURE:
      return {
        ...state,
        invoiceDraftPdfLoading: false,
        invoiceDraftPdfError: action.payload,
      };
    case INVOICE_DRAFT_DAILY_BALANCE_REQUEST:
      return {
        ...state,
        invoiceDraftDailyBalanceLoading: true,
        invoiceDraftDailyBalanceError: null,
      };
    case INVOICE_DRAFT_DAILY_BALANCE_SUCCESS:
      return {
        ...state,
        invoiceDraftDailyBalance: action.payload,
        invoiceDraftDailyBalanceLoading: false,
      };
    case INVOICE_DRAFT_DAILY_BALANCE_FAILURE:
      return {
        ...state,
        invoiceDraftDailyBalanceLoading: false,
        invoiceDraftDailyBalanceError: action.payload,
      };
    case INVOICE_DRAFT_STATUS_LIST_REQUEST:
      return {
        ...state,
        invoiceDraftStatusListLoading: true,
        invoiceDraftStatusListError: null,
      };
    case INVOICE_DRAFT_STATUS_LIST_SUCCESS:
      return {
        ...state,
        invoiceDraftStatusList: action.payload,
        invoiceDraftStatusListLoading: false,
      };
    case INVOICE_DRAFT_STATUS_LIST_FAILURE:
      return {
        ...state,
        invoiceDraftStatusListLoading: false,
        invoiceDraftStatusListError: action.payload,
      };
    case INVOICE_DRAFT_STATUS_DATA_REQUEST:
      return {
        ...state,
        invoiceDraftStatusDataLoading: true,
        invoiceDraftStatusDataError: null,
      };
    case INVOICE_DRAFT_STATUS_DATA_SUCCESS:
      return {
        ...state,
        invoiceDraftStatusData: action.payload,
        invoiceDraftStatusDataLoading: false,
      };
    case INVOICE_DRAFT_STATUS_DATA_FAILURE:
      return {
        ...state,
        invoiceDraftStatusDataLoading: false,
        invoiceDraftStatusDataError: action.payload,
      };
    case INVOICE_DRAFT_STATUS_CREATE_REQUEST:
      return {
        ...state,
        invoiceDraftStatusCreateLoading: true,
        invoiceDraftStatusCreateError: null,
      };
    case INVOICE_DRAFT_STATUS_CREATE_SUCCESS:
      return {
        ...state,
        invoiceDraftStatusCreate: action.payload,
        invoiceDraftStatusCreateLoading: false,
      };
    case INVOICE_DRAFT_STATUS_CREATE_FAILURE:
      return {
        ...state,
        invoiceDraftStatusCreateLoading: false,
        invoiceDraftStatusCreateError: action.payload,
      };
    case INVOICE_DRAFT_STATUS_UPDATE_REQUEST:
      return {
        ...state,
        invoiceDraftStatusUpdateLoading: true,
        invoiceDraftStatusUpdateError: null,
      };
    case INVOICE_DRAFT_STATUS_UPDATE_SUCCESS:
      return {
        ...state,
        invoiceDraftStatusUpdate: action.payload,
        invoiceDraftStatusUpdateLoading: false,
      };
    case INVOICE_DRAFT_STATUS_UPDATE_FAILURE:
      return {
        ...state,
        invoiceDraftStatusUpdateLoading: false,
        invoiceDraftStatusUpdateError: action.payload,
      };
    case INVOICE_DRAFT_STATUS_DELETE_REQUEST:
      return {
        ...state,
        invoiceDraftStatusDeleteLoading: true,
        invoiceDraftStatusDeleteError: null,
      };
    case INVOICE_DRAFT_STATUS_DELETE_SUCCESS:
      return {
        ...state,
        invoiceDraftStatusDelete: action.payload,
        invoiceDraftStatusDeleteLoading: false,
      };
    case INVOICE_DRAFT_STATUS_DELETE_FAILURE:
      return {
        ...state,
        invoiceDraftStatusDeleteLoading: false,
        invoiceDraftStatusDeleteError: action.payload,
      };
    case INVOICE_DRAFT_DATA_REQUEST:
      return {
        ...state,
        invoiceDraftDataLoading: true,
        invoiceDraftDataError: null,
      };
    case INVOICE_DRAFT_DATA_SUCCESS:
      return {
        ...state,
        invoiceDraftData: action.payload,
        invoiceDraftDataLoading: false,
      };
    case INVOICE_DRAFT_DATA_FAILURE:
      return {
        ...state,
        invoiceDraftDataLoading: false,
        invoiceDraftDataError: action.payload,
      };
    case INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_REQUEST:
      return {
        ...state,
        invoiceDraftActivityLogSearchLoading: true,
        invoiceDraftActivityLogSearchError: null,
      };
    case INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_SUCCESS:
      return {
        ...state,
        invoiceDraftActivityLogSearch: action.payload,
        invoiceDraftActivityLogSearchLoading: false,
      };
    case INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_FAILURE:
      return {
        ...state,
        invoiceDraftActivityLogSearchLoading: false,
        invoiceDraftActivityLogSearchError: action.payload,
      };
    case INVOICE_DRAFT_CONVERT_TO_INVOICE_REQUEST:
      return {
        ...state,
        invoiceDraftConvertToInvoiceLoading: true,
        invoiceDraftConvertToInvoiceError: null,
      };
    case INVOICE_DRAFT_CONVERT_TO_INVOICE_SUCCESS:
      return {
        ...state,
        invoiceDraftConvertToInvoice: action.payload,
        invoiceDraftConvertToInvoiceLoading: false,
      };
    case INVOICE_DRAFT_CONVERT_TO_INVOICE_FAILURE:
      return {
        ...state,
        invoiceDraftConvertToInvoiceLoading: false,
        invoiceDraftConvertToInvoiceError: action.payload,
      };
    default:
      return state;
  }
};

export default invoiceDraftReducer;
